(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-sticker-app-labels"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  const allowedIds = new Set(['10406239174920', '10406981599496', '10407130759432', '10407200260360', '10407328219400']);
  const originalFormats = 'Dateiformat: .ai / .eps / .pdf / .jpeg';

  function mount(root) {
    if (root.dataset.ssAppLabelsMounted || !allowedIds.has(root.dataset.productId) || !root.dataset.fileFormats) return;
    const parent = root.closest('.tt-product-single-info');
    if (!parent) return;
    root.dataset.ssAppLabelsMounted = 'true';

    function localize() {
      const app = parent.querySelector('#hulkapps_options_' + root.dataset.productId);
      if (!app) return;
      Array.from(app.children).forEach(function (heading) {
        if (heading.classList.contains('hulkapps_option_title') && heading.children.length === 0 && heading.textContent.trim() === 'Schnellkonfiguration:') {
          heading.hidden = true;
          heading.dataset.ssStickerDuplicateHeading = '';
        }
      });
      app.querySelectorAll('.hulkapps-tooltip span[aria-label]').forEach(function (label) {
        if (label.getAttribute('aria-label').trim() === originalFormats) label.setAttribute('aria-label', root.dataset.fileFormats);
      });
      app.querySelectorAll('.hulkapps-tooltip-inner[role="tooltip"]').forEach(function (tooltip) {
        if (tooltip.children.length === 0 && tooltip.textContent.trim() === originalFormats) tooltip.textContent = root.dataset.fileFormats;
      });
    }

    const observer = new MutationObserver(localize);
    observer.observe(parent, { childList: true, subtree: true, characterData: true });
    localize();
  }

  function mountAll() {
    document.querySelectorAll('[data-ss-sticker-app-labels]').forEach(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-sticker-configurator"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  const allowedIds = new Set(['10406239174920', '10406981599496', '10407130759432', '10407200260360', '10407328219400']);

  function runCount(option) {
    const match = String(option || '').trim().match(/^(\d+(?:[.,\s]\d{3})*)\s*[^\d]*$/u);
    if (!match) return null;
    const count = Number(match[1].replace(/[.,\s]/g, ''));
    return Number.isSafeInteger(count) && count > 0 ? count : null;
  }

  function quote(variant, packages) {
    if (!variant || variant.available !== true) return { state: 'unavailable' };
    if (!/^\d+$/.test(String(packages).trim())) return { state: 'quantityError' };
    const quantity = Number(packages);
    const count = runCount(variant.option3 || (variant.options && variant.options[2]));
    if (!Number.isSafeInteger(quantity) || quantity < 1) return { state: 'quantityError' };
    if (!count || !Number.isSafeInteger(variant.price) || variant.price < 0) return { state: 'pending' };
    const totalCents = variant.price * quantity;
    const totalUnits = count * quantity;
    if (!Number.isSafeInteger(totalCents) || !Number.isSafeInteger(totalUnits)) return { state: 'quantityError' };
    const unitAmount = variant.price / (100 * count);
    return { state: 'ready', totalCents, totalUnits, unitAmount, rounded: Math.abs(unitAmount - Number(unitAmount.toFixed(4))) > 1e-10 };
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { allowedIds, runCount, quote };
    return;
  }

  function mount(root) {
    if (root.dataset.ssMounted || !allowedIds.has(root.dataset.productId)) return;
    const source = root.querySelector('[data-ss-config-data]');
    const parent = root.closest('.tt-product-single-info');
    if (!source || !parent) return;
    let config;
    try { config = JSON.parse(source.textContent); } catch (_) { return; }
    const variantInput = parent.querySelector('form input.input_variant[name="id"]');
    const form = variantInput && variantInput.closest('form');
    const quantityInput = form && form.querySelector('input[name="quantity"]');
    if (!variantInput || !quantityInput || String(config.productId) !== root.dataset.productId) return;
    let money, unitMoney, number;
    try {
      money = new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency });
      unitMoney = new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency, minimumFractionDigits: 2, maximumFractionDigits: 4 });
      number = new Intl.NumberFormat(config.locale);
    } catch (_) { return; }
    root.dataset.ssMounted = 'true';
    let variant = config.variant;
    const summary = root.querySelector('[data-ss-summary]');
    const status = root.querySelector('[data-ss-status]');
    const swatches = root.querySelector('.tt-swatches-container-js');
    const labels = config.labels;
    let updateQueued = false;
    let pendingRun = null, chosenRun = null, choosingPreset = false, runRejected = false;
    const largeControls = document.createElement('div');
    largeControls.className = 'ss-sticker-large-runs';
    [2000, 5000].forEach(function (units) {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.ssLargeRun = String(units);
      button.textContent = number.format(units) + ' ' + labels.units;
      button.setAttribute('aria-pressed', 'false');
      largeControls.appendChild(button);
    });
    const largeHelp = document.createElement('p');
    largeHelp.className = 'ss-sticker-large-help'; largeHelp.hidden = true;
    function baseControl() {
      const group = swatches.children[2];
      return group && Array.from(group.querySelectorAll('a[data-value]')).find(function (control) { return runCount(control.dataset.value) === 1000; });
    }
    function setPackages(packages) {
      quantityInput.value = String(packages);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function applyPendingRun() {
      if (runRejected || !pendingRun || !variant || variant.available !== true || runCount(variant.option3 || variant.options?.[2]) !== 1000 || String(variantInput.value) !== String(variant.id)) return;
      const selectionMatches = swatches.children.length === 3 && Array.from(swatches.children).every(function (group, index) {
        const control = group.querySelector('li.active a[data-value]');
        return control && control.dataset.value === variant.options[index];
      });
      if (!selectionMatches) return;
      const requested = pendingRun;
      const packs = pendingRun / 1000;
      pendingRun = null; setPackages(packs);
      if (Number(quantityInput.value) !== packs) { pendingRun = requested; runRejected = true; }
    }
    function purchaseBlocked(event) {
      if (!pendingRun) return;
      event.preventDefault(); event.stopImmediatePropagation();
      status.hidden = false; status.textContent = labels.pending;
    }
    form.addEventListener('submit', purchaseBlocked, true);
    parent.addEventListener('click', function (event) {
      if (event.target.closest('.btn-addtocart, .addtocart-js, .shopify-payment-button')) purchaseBlocked(event);
    }, true);
    largeControls.addEventListener('click', function (event) {
      const button = event.target.closest('[data-ss-large-run]');
      const control = baseControl();
      if (!button || button.disabled || !control) return;
      chosenRun = Number(button.dataset.ssLargeRun); pendingRun = chosenRun; runRejected = false;
      parent.dataset.ssLargePending = 'true';
      choosingPreset = true;
      try { control.click(); } finally { choosingPreset = false; }
      applyPendingRun(); schedule();
    });
    function standardChoice(event) {
      if (choosingPreset) return;
      const control = event.target.closest('a[data-value], select');
      if (!control) return;
      const index = Array.from(swatches.children).findIndex(function (group) { return group.contains(control); });
      if (index === 2) { runRejected = false; chosenRun = null; pendingRun = null; setPackages(1); }
      else if (chosenRun && (index === 0 || index === 1)) { runRejected = false; pendingRun = chosenRun; parent.dataset.ssLargePending = 'true'; }
    }
    swatches.addEventListener('click', standardChoice, true);
    swatches.addEventListener('touchstart', standardChoice, true);
    swatches.addEventListener('change', standardChoice, true);
    document.body.dataset.ssStickerFixedRuns = 'true';

    function update() {
      applyPendingRun();
      parent.dataset.ssLargePending = String(Boolean(pendingRun));
      const largeActive = !pendingRun && runCount(variant?.option3 || variant?.options?.[2]) === 1000 && [2, 5].includes(Number(quantityInput.value));
      document.body.dataset.ssStickerLargeRun = String(largeActive || Boolean(pendingRun));
      const amountGroup = swatches.children[2];
      if (amountGroup) {
        amountGroup.dataset.ssLargeActive = String(largeActive);
        amountGroup.querySelectorAll('a[data-value]').forEach(function (control) { control.setAttribute('aria-pressed', String(!largeActive && control.parentElement.classList.contains('active'))); });
        const selected = amountGroup.querySelector('.current_option_name');
        if (largeActive && selected) selected.textContent = number.format(Number(quantityInput.value) * 1000) + ' ' + labels.units;
      }
      largeControls.querySelectorAll('button').forEach(function (button) {
        button.setAttribute('aria-pressed', String(largeActive && Number(button.dataset.ssLargeRun) === Number(quantityInput.value) * 1000));
      });
      largeHelp.hidden = !largeActive;
      largeHelp.textContent = largeActive ? number.format(Number(quantityInput.value)) + ' × ' + number.format(1000) + ' ' + labels.units : '';
      const currentVariantInput = parent.querySelector('form input.input_variant[name="id"]');
      const currentForm = currentVariantInput && currentVariantInput.closest('form');
      const currentQuantityInput = currentForm && currentForm.querySelector('input[name="quantity"]');
      const configured = swatches.children.length === 3 && Array.from(swatches.children).every(function (group) { return group.querySelector('li.active') || group.querySelector('select'); });
      const state = runRejected ? { state: 'quantityError' } : !pendingRun && configured && currentVariantInput && currentQuantityInput && String(currentVariantInput.value) === String(variant && variant.id)
        ? quote(variant, currentQuantityInput.value) : { state: 'pending' };
      summary.hidden = state.state !== 'ready';
      status.hidden = state.state === 'ready';
      if (state.state !== 'ready') {
        status.textContent = labels[state.state] || labels.pending;
        return;
      }
      root.querySelector('[data-ss-total]').textContent = money.format(state.totalCents / 100);
      root.querySelector('[data-ss-unit]').textContent = (state.rounded ? '≈ ' : '') + unitMoney.format(state.unitAmount);
      root.querySelector('[data-ss-count]').textContent = number.format(state.totalUnits) + ' ' + labels.units;
      root.querySelector('[data-ss-rounding]').hidden = !state.rounded;
      status.textContent = '';
    }

    function schedule() {
      if (updateQueued) return;
      updateQueued = true;
      Promise.resolve().then(function () {
        updateQueued = false;
        update();
      });
    }

    function optionLabel(index, value) {
      if (index === 2) {
        const count = runCount(value);
        if (count) return number.format(count) + ' ' + labels.units;
      }
      if (index === 1) return String(value).replace(/(\d)\s*[x×]\s*(\d)/gi, '$1 × $2').replace(/(\d)\s*cm$/i, '$1 cm');
      return value;
    }

    function enhanceGroups() {
      const names = [labels.finish, labels.size, labels.run];
      Array.from(swatches.children).forEach(function (group, index) {
        const heading = group.querySelector('.tt-title-options');
        if (!heading || !names[index]) return;
        if (!heading.dataset.ssStep) {
          const selected = heading.querySelector('.current_option_name');
          heading.textContent = names[index];
          if (selected) heading.appendChild(selected);
          heading.dataset.ssStep = String(index + 1).padStart(2, '0');
          heading.id = 'ss-sticker-option-' + config.productId + '-' + index;
        }
        group.setAttribute('role', 'group');
        group.setAttribute('aria-labelledby', heading.id);
        group.querySelectorAll('a[data-value]').forEach(function (control) {
          if (index > 0 && !control.classList.contains('options-color')) control.textContent = optionLabel(index, control.dataset.value);
          control.setAttribute('role', 'button');
          control.setAttribute('aria-pressed', String(control.parentElement.classList.contains('active')));
        });
        const selected = heading.querySelector('.current_option_name');
        const active = group.querySelector('li.active a[data-value]');
        if (selected && active) selected.textContent = optionLabel(index, active.dataset.value);
      });
      const amountGroup = swatches.children[2];
      if (amountGroup) {
        amountGroup.appendChild(largeControls); amountGroup.appendChild(largeHelp);
        const base = baseControl();
        largeControls.querySelectorAll('button').forEach(function (button) { button.disabled = !base || base.parentElement.dataset.availability === 'false'; });
      }
      schedule();
    }

    const quantityWrapper = quantityInput.closest('.tt-input-counter');
    if (quantityWrapper) {
      const column = quantityWrapper.closest('.col-item');
      if (column) column.dataset.ssFixedRunCounter = 'true';
      const label = document.createElement('p');
      label.className = 'ss-sticker-package-label';
      quantityInput.setAttribute('aria-label', labels.packages);
      label.textContent = labels.packages;
      quantityWrapper.before(label);
      const help = document.createElement('p');
      help.className = 'ss-sticker-package-help';
      help.id = 'ss-sticker-packages-help-' + config.productId;
      help.textContent = labels.packageHelp;
      const quantityRow = quantityWrapper.closest('.tt-row-custom-01');
      if (quantityRow) quantityRow.after(help);
      else quantityWrapper.after(help);
      quantityInput.setAttribute('aria-describedby', [quantityInput.getAttribute('aria-describedby'), help.id].filter(Boolean).join(' '));
      quantityInput.setAttribute('inputmode', 'numeric');
    }
    const nativePrice = Array.from(parent.children).find(function (child) { return child.classList.contains('tt-price'); });
    if (nativePrice) {
      const label = document.createElement('p');
      label.className = 'ss-sticker-package-price-label';
      label.textContent = labels.packagePrice;
      nativePrice.before(label);
    }

    document.addEventListener('ss:sticker:variant', function (event) {
      if (!event.detail || String(event.detail.productId) !== root.dataset.productId) return;
      variant = event.detail.variant;
      applyPendingRun();
      schedule();
    });
    parent.addEventListener('input', schedule);
    parent.addEventListener('change', schedule);
    parent.addEventListener('click', schedule);
    swatches.addEventListener('keydown', function (event) {
      const target = event.target.closest('a[data-value]');
      if (target && event.key === ' ') { event.preventDefault(); target.click(); }
    });
    const observer = new MutationObserver(enhanceGroups);
    observer.observe(swatches, { childList: true });
    enhanceGroups();
    update();
  }

  function mountAll() {
    document.querySelectorAll('[data-ss-sticker-config]').forEach(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-sticker-custom-options"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  const values = { freeform: 'Freiform', rectangle: 'Rechteck', circle: 'Kreis', rounded: 'Abgerundete Ecken' };
  function mount(host) {
    if (host.dataset.ssShapeMounted) return;
    const root = host.closest('[data-ss-sticker-config]');
    const parent = root && root.closest('.tt-product-single-info');
    const form = parent && parent.querySelector('form input.input_variant[name="id"]')?.closest('form');
    const swatches = root && root.querySelector('.tt-swatches-container-js');
    if (!form || !swatches) return;
    host.dataset.ssShapeMounted = 'true';
    let input = form.querySelector('input[name="properties[Form]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = 'properties[Form]';
      form.appendChild(input);
    }
    input.value = values.freeform;
    host.addEventListener('click', function (event) {
      const button = event.target.closest('[data-ss-shape]');
      if (!button || !host.contains(button) || !Object.hasOwn(values, button.dataset.ssShape)) return;
      input.value = values[button.dataset.ssShape];
      host.querySelectorAll('[data-ss-shape]').forEach(function (control) {
        control.setAttribute('aria-pressed', String(control === button));
      });
    });
    swatches.before(host);
    host.hidden = false;
  }
  function mountAll() { document.querySelectorAll('[data-ss-shape-root]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true }); else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
}());
  } catch(e) { console.error(e); }
})();

})();
